package games.polyclub.website.frontend.store.pages.product

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.p
import games.polyclub.frontend.lib.react.simplified.tags.strong
import react.Props

val AccessPassInfo = SFC<Props> { _ ->
    p {
        +"Para jogar em nosso servidor, você precisa ter o jogo Minecraft Java Edition original, o modpack GameMods: All Of Fabric instalado e um Passe de Acesso."
    }
    p {
        +"A quantidade de passes de acesso vendidos são "
        strong {
            +"LIMITADOS"
        }
        +"! Após o limite ser atingido, não será possível comprar novos passes (apenas renová-los) até que uma nova análise seja feita pela equipe para determinar se o servidor pode ou não ser expandido."
    }
    p {
        +"O Passe de Acesso tem duração de "
        strong {
            +"30 dias"
        }
        +" que começa a contar a partir do seu primeiro login no servidor, exceto em fase beta, durante a fase beta você poderá jogar normalmente sem iniciar a contagem de tempo do seu passe."
    }
}
